const UserService = {

  update(userId, payload) {
    return new Promise((resolve, reject) => {
      axios.patch(`users/${userId}`, payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },

};

export default UserService;
